import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserDefaultService } from 'src/app/shared/services/user-default.service';

@Component({
  selector: 'app-purchaser-range',
  templateUrl: './purchaser-range.component.html',
  styleUrls: [],
  standalone: false
})
export class PurchaserRangeComponent implements OnInit {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor(private uds: UserDefaultService) {}

  ngOnInit(): void {
    // Apply default values only if both from and to are empty
    if (!this.from && !this.to) {
      this.uds.getDefaultPurchaser().subscribe(res => {
        if (res?.code) {
          // Set both from and to to the default purchaser code
          this.from = res.code;
          this.to = res.code;
          // Emit the changes to notify parent components
          this.fromChange.emit(res.code);
          this.toChange.emit(res.code);
        }
      });
    }
  }
}
